// Copyright 2016 Sorama B.V.

import { IWorkflowPropertyParser } from "libraries/WorkflowFramework/Interfaces/IWorkflowPropertyParser";
import * as LZString from "lz-string";
import { ChannelSelection } from "services/ChannelSelection/ChannelSelection";

export class ChannelSelectionParser implements IWorkflowPropertyParser<ChannelSelection> {
    public toWorkflowProperty(selection: ChannelSelection): string {
        if (!selection) return "";

        // Convert to selection string
        const selectionString = ChannelSelection.toSelectionString(selection);

        // Convert binary string to hex string
        const hexString = selectionString;

        // Compress string to base64
        return LZString.compressToBase64(hexString);
    }

    public fromWorkflowProperty(str: unknown): ChannelSelection {
        if (!str || typeof str !== "string") return null;

        // Decompress from base64 string
        const decompressed = LZString.decompressFromBase64(<string>str);
        if (!decompressed) return null;

        const binString = decompressed;

        // Create a channel selection from the string
        return ChannelSelection.fromSelectionString(binString);
    }

    //private toHexString(binString: string): string
    //{
    //    const hexString = "";
    //    for (let i = 0; i < binString.length; i+=4)
    //    {
    //        const hexDigit = 0;
    //        for (let j = 0; j < 4 && j + i < binString.length; j++)
    //        {
    //            if (binString[j + i] === "1")
    //            {
    //                hexDigit += 1 << j;
    //            }
    //        }
    //        hexString += hexDigit.toString(16);
    //    }

    //    return hexString;
    //}

    //private toBinString(hexString: string): string
    //{
    //    const binString = "";
    //    for (let i = 0; i < hexString.length; i++)
    //    {
    //        const num = parseInt(hexString[i + j], 16);

    //        for (let j = 0; j < 4; j++)
    //        {
    //            if (binString[j + i] === "1")
    //            {
    //                hexDigit += 1 << j;
    //            }
    //        }
    //        hexString += hexDigit.toString(16);
    //    }

    //    return hexString;
    //}
}
